//import Controller from "../Engine/Controller";
import Engine from "../Engine/Engine";
import cfJS from "../Engine/cfJS";

class Notice {

    constructor(text, type) {
        if (!text || text.length===0) {
            this.remove();
            return;
        }

        let html = (type=="error" ? "<div class=\"default error\">\n" : "<div class=\"default\">\n") +
            text +
            "</div>";

        let dom = cfJS.querySelector(document.body,".notices_container");

        dom.innerHTML = html;
        dom.style.zIndex = 1001;
        dom.style.display = "block";
        let that = this;

        setTimeout(function () {
            dom.innerHTML = "";
            dom.style.display = "none";
            that.remove();
        },3000);
    }
    /*
    * remove this class
    */
    remove() {
        delete this;
    }

}

window.Notice = Notice;
